var _excluded = ["btrCount"],
  _excluded2 = ["searchAutocompleteUrlBase", "browseUrlFormat"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { ListingType, LocalityState, deobfuscateString, gaHelper } from '@domain-group/fe-allhomes-library';
import { AdProvider } from '@domain-group/fe-co-allhomes-ads';
import { AllhomesDreamHomes } from '@domain-group/fe-co-allhomes-dream-homes';
import { AllhomesPropertyOfTheWeek } from '@domain-group/fe-co-allhomes-property-of-the-week';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesSearchFrontpage, { BaseAllhomesSearchFrontpage } from './components/allhomes-search-frontpage';
import { NewsBlock } from './components/news-block/news-block';
import AllhomesAppDownload from './components/app-download';
import allhomesHomepageWrapper from './allhomes-homepage-wrapper';
import HomepageAdSpot from './components/homepage-ad-spot';
import { Banner, Illustration, BtrIllustration } from './components/cta-banner';
import ResearchDriver from './components/research-driver';
import getAdTargeting from './get-ad-targeting';
var Illustration25Yrs = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-homepage/static/25-years_73fb97ec.png";
import * as styles from './allhomes-homepage.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesHomepage = _ref => {
  var btrCount = _ref.btrCount,
    props = _objectWithoutProperties(_ref, _excluded);
  var listingTypeSelectedHandler = type => {
    var listingTypeNames = {
      [ListingType.SALES_RESIDENTIAL.name]: 'Buy',
      [ListingType.RENTAL_RESIDENTIAL.name]: 'Rent',
      [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: 'New Homes',
      [ListingType.SHARE_RESIDENTIAL.name]: 'Share',
      [ListingType.SALES_COMMERCIAL]: 'Sale',
      [ListingType.RENTAL_COMMERCIAL]: 'Lease',
      [ListingType.SALES_BUSINESS]: 'Business'
    };
    if (type in listingTypeNames) {
      gaHelper.interactionEvent("Select Property Type - ".concat(listingTypeNames[type]));
    } else {
      gaHelper.interactionEvent("Select Property Type - Undefined type (".concat(type, ")"));
    }
  };
  var selectStateHandler = state => {
    if (state === LocalityState.ACT.abbreviation) {
      gaHelper.interactionEvent('Browse ACT');
    } else {
      gaHelper.interactionEvent("Select State - ".concat(state));
    }
  };
  var searchButtonClickHandler = () => {
    gaHelper.interactionEvent('Search Button');
  };
  var recentSearchClickHandler = () => {
    gaHelper.interactionEvent('Select Recent Search');
  };
  var propertyOfTheWeekCardClickHandler = (card, index) => {
    gaHelper.interactionEvent("Property of the Week - Position ".concat(index + 1));
  };
  var dreamHomesClickHandler = (card, index) => {
    gaHelper.interactionEvent("Dream Homes - Position ".concat(index + 1));
  };
  var appStoreClickHandler = () => {
    gaHelper.downloadsEvent('iOS');
  };
  var googlePlayClickHandler = () => {
    gaHelper.downloadsEvent('Android');
  };
  var searchAutocompleteUrlBase = props.searchAutocompleteUrlBase,
    browseUrlFormat = props.browseUrlFormat,
    finalProps = _objectWithoutProperties(props, _excluded2);
  searchAutocompleteUrlBase = deobfuscateString(searchAutocompleteUrlBase);
  browseUrlFormat = deobfuscateString(browseUrlFormat);
  finalProps = _objectSpread({
    searchAutocompleteUrlBase,
    browseUrlFormat
  }, finalProps);
  return ___EmotionJSX(AdProvider, {
    targeting: getAdTargeting()
  }, ___EmotionJSX("div", {
    css: styles.homepage
  }, ___EmotionJSX("div", {
    css: styles.searchWrapper
  }, ___EmotionJSX(AllhomesSearchFrontpage, _extends({}, finalProps, {
    onStateSelect: selectStateHandler,
    onOptionChange: listingTypeSelectedHandler,
    onSearch: searchButtonClickHandler,
    onRecentSearch: recentSearchClickHandler
  }))), ___EmotionJSX("div", {
    css: styles.adUnit,
    id: "ad-unit-homepage"
  }, !props.disableAds && ___EmotionJSX(HomepageAdSpot, null)), !isEmpty(props.propertyOfTheWeeks) && ___EmotionJSX("div", {
    css: styles.cardWrapper
  }, ___EmotionJSX(EventBoundary, {
    data: {
      listingType: props.listingType
    }
  }, ___EmotionJSX(AllhomesPropertyOfTheWeek, {
    listings: props.propertyOfTheWeeks,
    onClick: propertyOfTheWeekCardClickHandler
  }))), ___EmotionJSX(Banner, {
    isMobile: props.media.mobile,
    line1: "For 25 years, Canberra has been our home.",
    line2: "Now, it's our turn to give back.",
    description: "Each month, we're giving away prizes that celebrate unique local experiences, support locally owned businesses, and amplify local impact by spotlighting the work of our community partners. It's our way of saying thanks for being part of our journey throughout the past 25 years.",
    ctaLabel: "Enter to win",
    ctaUrl: "/community",
    illustration: ___EmotionJSX(Illustration, {
      src: Illustration25Yrs
    })
  }), props.medianPriceItems.length > 0 && ___EmotionJSX("div", {
    css: styles.cardWrapper
  }, ___EmotionJSX(ResearchDriver, {
    medianPriceItems: props.medianPriceItems
  })), !isEmpty(props.news.articleGroups) && ___EmotionJSX(NewsBlock, props.news), !isEmpty(props.dreamHomes) && ___EmotionJSX(EventBoundary, {
    data: {
      listingType: props.listingType
    }
  }, ___EmotionJSX(AllhomesDreamHomes, {
    dreamhomes: props.dreamHomes,
    onClick: dreamHomesClickHandler
  })), btrCount > 0 && [ListingType.RENTAL_RESIDENTIAL.name, ListingType.SALES_RESIDENTIAL.name].includes(props.listingType) && ___EmotionJSX(Banner, {
    appearance: "btr",
    isMobile: props.media.mobile,
    line1: "Allhomes introduces the 'Build-to-Rent' category",
    description: "Build-to-Rent properties may offer a more stable lease than other rentals because they are not intended to be individually sold. They may also come with great amenities and services, making them a turn-key opportunity, whilst giving tenants more housing choices.",
    ctaLabel: "See ".concat(btrCount, " Build-to-Rent development").concat(btrCount > 1 ? 's' : ''),
    ctaUrl: "/rent/search?listingtypes=build-to-rent",
    illustration: ___EmotionJSX(BtrIllustration, null)
  }), ___EmotionJSX(AllhomesAppDownload, {
    onAppStoreClick: appStoreClickHandler,
    onGooglePlayClick: googlePlayClickHandler
  })));
};
AllhomesHomepage.propTypes = _objectSpread(_objectSpread({}, BaseAllhomesSearchFrontpage.propTypes), {}, {
  hero: PropTypes.shape(),
  userPreferenceKey: PropTypes.string,
  propertyOfTheWeeks: PropTypes.arrayOf(PropTypes.shape({})),
  news: PropTypes.shape({}).isRequired,
  dreamHomes: PropTypes.arrayOf(PropTypes.shape({})),
  disableAds: PropTypes.bool,
  medianPriceItems: PropTypes.arrayOf(PropTypes.shape({
    houseMedianPrice: PropTypes.string,
    housePriceYearlyDelta: PropTypes.number,
    unitMedianPrice: PropTypes.string,
    unitPriceYearlyDelta: PropTypes.number,
    districtName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  })),
  btrCount: PropTypes.number
});

/* eslint-disable react/default-props-match-prop-types */
AllhomesHomepage.defaultProps = {
  listingType: ListingType.SALES_RESIDENTIAL.name,
  browseUrlFormat: '/ah/%state/sale-residential',
  userPreferenceKey: 'new_homepage',
  disableAds: false,
  propertyOfTheWeeks: [],
  dreamHomes: [],
  hero: undefined,
  medianPriceItems: [],
  btrCount: 0
};
export default allhomesHomepageWrapper(AllhomesHomepage);
export { AllhomesHomepage as BaseAllhomesHomepage };